import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">探索爱的维度</h2>
          <p className="text-sm text-foreground-600 max-w-xl mx-auto">
            爱有千万种面貌。选择你感兴趣的方向，开启一段深情的探索之旅。
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-lg border border-background-200/70 p-6 hover:border-primary-200 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-50 text-primary-500 mb-5 group-hover:bg-primary-500 group-hover:text-background-50 transition-colors duration-300">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-950 mb-2">{cat.name}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{cat.description}</p>
              <span className="text-xs text-foreground-400 flex items-center gap-1">
                {cat.articleCount} 篇文章
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line"></i>
                </span>
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}